import { Text } from "@mantine/core";
import { forwardRef } from "react";
import type { ChatTask } from "@/sdk/agent/chat";
import { formatTime } from "@/shared-utils";

import { ListItemSeparator } from "./ListItemSeparator";

// TODO: add more chat ended reasons as we know them
const StyledEndReason = ({ chatTask }: { chatTask: ChatTask }) => {
    if (chatTask.isClosedByCustomer) {
        return (
            <>
                &nbsp;-&nbsp;
                <Text size="xs" fw={700} c="yellow.6">
                    {"Closed by customer"}
                </Text>
            </>
        );
    } else if (chatTask.wasCustomerDisconnected) {
        return (
            <>
                &nbsp;-&nbsp;
                <Text size="xs" fw={700} c="yellow.6">
                    {"Customer disconnected"}
                </Text>
            </>
        );
    } else return null;
};

export const ChatEndedSeparator = forwardRef<HTMLDivElement, { chatTask: ChatTask }>(function ChatEndedSeparator(
    { chatTask },
    ref,
) {
    const stateLastChangedAt = chatTask.stateLastChangedAt;
    const dateCreated = chatTask.dateCreated;

    if (stateLastChangedAt && dateCreated) {
        const endedAt = stateLastChangedAt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
        const duration = formatTime((stateLastChangedAt.getTime() - dateCreated.getTime()) / 1000, true);

        return (
            <ListItemSeparator
                label={
                    <>
                        {`Chat ended at ${endedAt} | ${duration}`}
                        <StyledEndReason chatTask={chatTask} />
                    </>
                }
                ref={ref}
            />
        );
    }
    return <ListItemSeparator label={`Chat ended`} ref={ref} />;
});
